export const ShippingAccountContract  = {
    async index() {
        throw new Error("index_shipping_accounts not implemented");
    }
}